/* eslint no-param-reassign: 0 */
/* eslint no-unused-vars: 0 */
/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */

import GameFactory from './gameFactory';

const mainState = {
  currentGame: null,
  // gamesById: {},
};

// const getters = {
//   currentGame: state => id => state.gamesById[id],
// };

const mutations = {
  createGame(state, config) {
    state.currentGame = new GameFactory(config.game, config);
  },
  move(state, { from, to }) {
    state.currentGame.move(from, to);
  },
  endGame(state) {
    state.currentGame = null;
  },
};

const actions = {
  createGame({ commit }, config) {
    commit('createGame', config);
  },
  move({ commit }, { from, to }) {
    commit('move', { from, to });
  },
  endGame({ commit }) {
    commit('endGame');
  },
};

export default {
  state: mainState,
  mutations,
  actions,
};
